// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn.answerButton[data-v-1a842c04]{color:green}.v-btn.answerButton[data-v-1a842c04]:not(:focus):hover{color:red}.v-btn.answerButton[data-v-1a842c04]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
